<script setup>
import { storeToRefs } from 'pinia'
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { toast } from 'vue3-toastify'

import { useLearningAuthStore } from '@stores/auth'
import { useLearningUserStore } from '@stores/user'
import DefineValidation from '@services/validation/DefineValidation'
import Modal from '@components/modal/Modal.vue'
import learningApiUser from '@src/services/api/learning/user'
import { consumeSessionExpiredLogout, SESSION_EXPIRED_MESSAGE } from '@utils/commonUtil'

const { login, resetAuth } = useLearningAuthStore()
const { setUserInfo } = useLearningUserStore()

const { accessToken, userLogging } = storeToRefs(useLearningAuthStore())

const { errors, meta, handleSubmit, handleReset, models } = new DefineValidation((modules) => {
  return {
    login_id: modules.string().required().label('ログインID'),
    password: modules.string().required().label('パスワード')
  }
})
const sendButtonDisabled = ref(false)
const router = useRouter()

const isShownErrorModal = ref(false)
const hideErrorModal = () => {
  isShownErrorModal.value = false
}

const sendForm = handleSubmit(async (values) => {
  sendButtonDisabled.value = true
  console.log('sendForm', values)
  console.log('sendForm', accessToken.value, userLogging.value)
  await login({
    username: values.login_id,
    password: values.password
  }).then(async () => {
    learningApiUser.getUser().then((res) => {
      console.log('getUser res', res)
      // console.log('userInfo', userInfo)
      setUserInfo(res.data)
      handleReset()
      router.push({
        name: 'Dashboard'
      })
    }).catch((err) => {
      console.error('getUser err', err)
    })
  }).catch((err) => {
    console.log('login err', err)
    sendButtonDisabled.value = false
    if (err.response.status === 401) {
      isShownErrorModal.value = true
    }
  })
})

resetAuth()

onMounted(() => {
  if (consumeSessionExpiredLogout()) {
    toast(SESSION_EXPIRED_MESSAGE, { type: 'info' })
  }
})

const isShownPassword = ref(false)
const togglePasswordSeek = () => {
  isShownPassword.value = !isShownPassword.value
}

// 利用規約の同意をクリア
sessionStorage.removeItem('jcla_group_register_agreement')
</script>

<template>
  <div class="container">
    <section class="login">
      <form
        class="l-page__wrapper"
        @submit.prevent="sendForm"
      >
        <p class="login__text">ログイン</p>
        <div class="login__form">
          <div class="p-form-field">
            <label
              for="login_id"
              class="c-input-label"
            >ログインID</label>
            <input
              id="login_id"
              v-model="models.login_id.value"
              type="text"
              class="c-input-text"
              placeholder="入力してください"
              autocomplete="off"
              maxlength="256"
            >
            <span
              v-if="errors.email"
              class="c-validationError"
            >{{ errors.email }}</span>
          </div>
          <div class="p-form-field">
            <label
              for="password"
              class="c-input-label"
            >パスワード</label>
  
            <input
              v-model="models.password.value"
              :type="isShownPassword ? 'text' : 'password'"
              class="c-input-password"
              placeholder="入力してください"
              autocomplete="off"
              maxlength="32"
            >
            <div class="c-password-btn" @click="togglePasswordSeek">
              <img :src="isShownPassword ? require('@assets/images/icon/icon-hidden.svg') : require('@assets/images/icon/icon-display.svg')">
            </div>
  
            <span
              v-if="errors.password"
              class="c-validationError"
            >{{ errors.password }}</span>
          </div>
        </div>
        <div class="login__actions">
          <RouterLink
            class="login__remind"
            :to="{name:'ReminderAccountInputMail'}"
          >
            ログインIDを忘れた方はこちら
          </RouterLink>
          <RouterLink
            class="login__remind"
            :to="{name:'ReminderInputMail'}"
          >
            パスワードを忘れた方はこちら
          </RouterLink>
          <button
            type="submit"
            class="c-button c-button--medium c-button--black"
            :disabled="sendButtonDisabled"
          >
            ログイン
          </button>

          <RouterLink
            class="c-button c-button--medium c-button--border u-mt-24"
            :to="{name:'RegisterInput'}"
          >
            新規登録はこちら
          </RouterLink>
        </div>
      </form>

      <Modal :show="isShownErrorModal">
        <template #body>
          <div class="l-modal__body">
            <h2 class="l-modal__ttl">
              IDまたはパスワードが間違っています。
            </h2>
            <div class="l-modal__buttons">
              <button
                class="c-modalBtn c-modalBtn--single c-modalBtn--gray"
                type="button"
                @click="hideErrorModal"
              >
                閉じる
              </button>
            </div>
          </div>
        </template>
      </Modal>
    </section>
  </div>
</template>

<style scoped lang="scss">
.login{
  max-width: 450px;
  margin: 0 auto;
  padding-top: 64px;

  &__text {
    text-align: center;
    font-size: 20px;
    font-weight: var(--fwBold);
    margin-bottom: 20px;
  }
  &__logo {
    width: 139px;
    height: auto;
    margin: 0 auto 53px;
    display: block;
  }

  &__form{
    margin-bottom: 40px;
  }

  &__remind{
    display: block;
    text-align: center;
    color: #000;
    text-decoration: underline;
    font-size: 1.3rem;
    margin-bottom: 10px;

    &:nth-child(2){
      margin-bottom: 40px;
    }
  }
}
</style>
